import React, { useEffect, useState } from "react";
import { FiShield, FiCheckCircle, FiAlertTriangle } from "react-icons/fi";
import { cguAPI } from "../../services/api";

// Brique 2 — Registre d'acceptation des CGU (admin) : qui a accepté quoi, quand, depuis quelle IP.
const AdminCGU = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roleFilter, setRoleFilter] = useState("");
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await cguAPI.adminRegistry(roleFilter ? { role: roleFilter } : {});
      const data = (res && res.data && res.data.data) || [];
      setRows(data);
    } catch (e) {
      setError("Erreur de chargement du registre.");
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [roleFilter]);

  const fmt = (d) => (d ? new Date(d).toLocaleString("fr-FR") : "—");

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#fdecf5] text-[#e11d7b]">
          <FiShield size={20} />
        </span>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Registre d'acceptation des CGU</h1>
          <p className="text-sm text-gray-500">Preuve juridique : version acceptée, date et IP par utilisateur.</p>
        </div>
      </div>

      <div className="mb-4 flex items-center gap-2">
        <label className="text-sm text-gray-600">Filtrer par rôle :</label>
        <select
          value={roleFilter}
          onChange={(e) => setRoleFilter(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm"
        >
          <option value="">Tous</option>
          <option value="user">Acheteurs</option>
          <option value="merchant">Marchands</option>
        </select>
      </div>

      {error && <p className="text-sm text-red-600 mb-3">{error}</p>}

      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="text-left px-4 py-3 font-semibold">Utilisateur</th>
              <th className="text-left px-4 py-3 font-semibold">Rôle</th>
              <th className="text-left px-4 py-3 font-semibold">Version acceptée</th>
              <th className="text-left px-4 py-3 font-semibold">À jour</th>
              <th className="text-left px-4 py-3 font-semibold">Date</th>
              <th className="text-left px-4 py-3 font-semibold">IP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr><td colSpan={6} className="px-4 py-6 text-center text-gray-400">Chargement…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={6} className="px-4 py-6 text-center text-gray-400">Aucune donnée.</td></tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id}>
                  <td className="px-4 py-3">
                    <div className="font-medium text-gray-900">{r.name}</div>
                    <div className="text-xs text-gray-500">{r.email}</div>
                  </td>
                  <td className="px-4 py-3 text-gray-700">{r.role}</td>
                  <td className="px-4 py-3 text-gray-700">{r.acceptedVersion || "—"}</td>
                  <td className="px-4 py-3">
                    {r.upToDate ? (
                      <span className="inline-flex items-center gap-1 text-green-600"><FiCheckCircle size={14} /> Oui</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-amber-600"><FiAlertTriangle size={14} /> Non</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-gray-600">{fmt(r.acceptedAt)}</td>
                  <td className="px-4 py-3 text-gray-500">{r.acceptedIp || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCGU;
